import { __assign, __awaiter, __generator } from "tslib";
import { composer } from '../../../../component-decorators/composer';
import { useConfigContext } from '../../../../config-context';
import * as React from 'react';
import { Box, Button, Heading, Loader, Text } from 'wix-style-react';
import { getTagsDataBySlugs } from '../../../../api/api';
import { SolutionGridWrapper, } from '../../../solution-grid-wrapper/solution-grid-wrapper';
import { getWebSolutionsBiData } from '../../biData';
import { biLogger } from '../../../../bi';
import s from './discovery.scss';
import { config } from '../../../../config';
import { SolutionGridLayout } from '@wix/app-market-collection-widget';
import { selectorButtonsClassNamesV1, selectorButtonsClassNamesV2, } from './types';
import { FluidContainer } from '../../../FluidContainer';
export var discoverySectionDTOtoProps = function (sectionDTO) {
    var tagData = sectionDTO.tagData;
    var tagsToWebSolutions = tagData.tagsToWebSolutions;
    return tagsToWebSolutions;
};
export var Discovery = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var tagsToWebSolutions = _a.tagsToWebSolutions, experiments = _a.experiments, t = _a.t, impressionId = _a.impressionId;
    // tslint:disable-next-line:react-hooks-nesting
    var _b = useConfigContext(), locale = _b.locale, countryCode = _b.countryCode;
    // tslint:disable-next-line:react-hooks-nesting
    var _c = React.useState(true), showAnimation = _c[0], setShowAnimation = _c[1];
    // tslint:disable-next-line:react-hooks-nesting
    var _d = React.useState(null), selectedSlug = _d[0], setSelectedSlug = _d[1];
    // tslint:disable-next-line:react-hooks-nesting
    var _e = React.useState(false), isFetching = _e[0], setIsFetching = _e[1];
    // tslint:disable-next-line:react-hooks-nesting
    var _f = React.useState([]), solutions = _f[0], setSolutions = _f[1];
    var loadSolutionsBySlug = function (slug, 
    // tslint:disable-next-line:no-shadowed-variable
    experiments, 
    // tslint:disable-next-line:no-shadowed-variable
    locale, 
    // tslint:disable-next-line:no-shadowed-variable
    countryCode) {
        if (countryCode === void 0) { countryCode = 'us'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var tagsData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsFetching(true);
                        return [4 /*yield*/, getTagsDataBySlugs([slug], false, locale, countryCode, true, true)];
                    case 1:
                        tagsData = _b.sent();
                        setSolutions((_a = tagsData === null || tagsData === void 0 ? void 0 : tagsData.webSolutions) === null || _a === void 0 ? void 0 : _a.map(function (solution) {
                            return __assign({}, solution === null || solution === void 0 ? void 0 : solution.baseInfo);
                        }));
                        setIsFetching(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    // tslint:disable-next-line:react-hooks-nesting
    React.useEffect(function () {
        selectedSlug &&
            loadSolutionsBySlug(selectedSlug, experiments, locale, countryCode);
    }, [selectedSlug]);
    // tslint:disable-next-line:react-hooks-nesting
    React.useEffect(function () {
        biLogger.appMarketAppCollectionImpressions({
            collimp_id: impressionId,
            tag_name: 'discovery',
            tag_type: 'homepage',
            collection_index: 0,
        });
    }, []);
    var newDesign = true;
    var className = newDesign
        ? selectorButtonsClassNamesV2
        : selectorButtonsClassNamesV1;
    var goBackToEmptyState = function () {
        setSelectedSlug(null);
        setSolutions([]);
    };
    var onLabelClick = function (slug, index) {
        biLogger.appMarketCollectionsPills({
            collimp_id: impressionId,
            index: index,
            market: config === null || config === void 0 ? void 0 : config.originForBI,
            slug_id: slug,
        });
        showAnimation && setShowAnimation(false);
        selectedSlug && selectedSlug === slug
            ? goBackToEmptyState()
            : setSelectedSlug(slug);
    };
    var DiscoverySelectorButton = composer()
        .withMarketplaceStore()
        .withExperiments()
        .compose(function (_a) {
        var tag = _a.tag, tagIndex = _a.tagIndex;
        var isSelected = selectedSlug && selectedSlug === tag.slug;
        return (React.createElement(Button, { className: className.selectorButton + " " + (isSelected
                ? className.selectorButtonSelected
                : className.selectorButtonUnselected), skin: 'inverted', onClick: function () { return onLabelClick(tag.slug, tagIndex); }, key: "selector-" + tagIndex, dataHook: tag.slug + "-selector" }, tag.name));
    });
    var SolutionGridSection = composer()
        .withMarketplaceStore()
        .compose(function (_a) {
        var marketplaceStore = _a.marketplaceStore;
        var solutionGridWrapperProps = getDiscoverySolutionGridProps(solutions, selectedSlug, marketplaceStore, impressionId, newDesign);
        return (React.createElement(Box, { direction: "vertical", dataHook: "discovery-solution-grid-section" },
            !newDesign && (React.createElement(Box, { paddingBottom: "3px" },
                React.createElement(Text, { weight: "bold", dataHook: "discovery-solution-grid-section-title" }, t('marketplace.discovery.solution-grid.title', {
                    numberOfApps: solutions === null || solutions === void 0 ? void 0 : solutions.length,
                })))),
            React.createElement(SolutionGridWrapper, __assign({}, solutionGridWrapperProps))));
    });
    var DiscoveryBottomSection = composer().compose(function () {
        var paddingTop = isFetching || (solutions === null || solutions === void 0 ? void 0 : solutions.length) ? (newDesign ? '15px' : '24px') : '';
        var paddingBottom = isFetching ? '6px' : '';
        return (React.createElement(Box, { paddingTop: paddingTop, paddingBottom: paddingBottom, flexFlow: "column", dataHook: "discovery-bottom-section" }, isFetching ? (React.createElement(CenteredLoader, { newDesign: newDesign })) : (solutions === null || solutions === void 0 ? void 0 : solutions.length) ? (React.createElement(SolutionGridSection, null)) : ('')));
    });
    var DiscoverySelector = composer()
        .withExperiments()
        .withTranslation()
        // tslint:disable-next-line:no-shadowed-variable
        .compose(function (_a) {
        var tagsToWebSolutions = _a.tagsToWebSolutions;
        var align = newDesign ? 'center' : 'left';
        return (React.createElement(Box, { direction: "vertical", align: align, dataHook: "discovery-selector" },
            React.createElement(Box, { className: showAnimation && className.selectorTitleAnimation, dataHook: "discovery-selector-title" },
                React.createElement(Heading, { appearance: "H1", light: newDesign }, t('marketplace.discovery.title'))),
            React.createElement(Box, { paddingTop: "20px", dataHook: "discovery-selector-buttons", align: align, className: s.selectorButtons + " " + (showAnimation &&
                    className.selectorButtonsAnimation) }, tagsToWebSolutions
                .map(function (_) { return _.tag; })
                .map(function (tag, tagIndex) { return (
            // tslint:disable-next-line:jsx-key
            React.createElement(DiscoverySelectorButton, { tag: tag, tagIndex: tagIndex })); }))));
    });
    var selectorBackground = newDesign
        ? (solutions === null || solutions === void 0 ? void 0 : solutions.length) ? s.selectorFullBackgroundNew
            : s.selectorHeaderBackgroundNew
        : s.selectorFullBackground;
    return (React.createElement(Box, { paddingTop: "40px", direction: "vertical", className: selectorBackground, dataHook: "discovery-widget" },
        React.createElement(FluidContainer, null,
            React.createElement(DiscoverySelector, { tagsToWebSolutions: tagsToWebSolutions }),
            React.createElement(DiscoveryBottomSection, null))));
});
var CenteredLoader = function (_a) {
    var newDesign = _a.newDesign;
    return (React.createElement(Box, { width: "100%", align: "center" },
        React.createElement(Loader, { status: "loading", size: "small", color: newDesign ? 'white' : 'blue' })));
};
var getDiscoverySolutionGridProps = function (solutions, selectedSlug, marketplaceStore, impressionId, newDesign) {
    var solutionsBiData = getWebSolutionsBiData(solutions, 'box', selectedSlug, marketplaceStore.metaSiteId, marketplaceStore.route, marketplaceStore.prevRoute, marketplaceStore.bundleApps, impressionId, 'discovery');
    var solutionGridWrapperProps = {
        solutions: solutions,
        isCompany: true,
        referralSectionName: selectedSlug,
        section: 'discovery',
        solutionsBiData: solutionsBiData,
        sortSolutions: true,
        layout: newDesign
            ? SolutionGridLayout.MARKETPLACE
            : SolutionGridLayout.INTEGRATIONS,
    };
    return solutionGridWrapperProps;
};
//# sourceMappingURL=discovery.js.map